module.exports = ".alert {\n  margin-bottom: 0;\n  padding-left: 0;\n  padding-right: 0; }\n\n.logo {\n  width: 175px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/login/basic-login/basic-login.component.scss
// module id = ./src/app/auth/login/basic-login/basic-login.component.scss
// module chunks = basic-login.module